import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-5 text-left",
  style: {"margin-top":"0"}
}
const _hoisted_2 = ["innerHTML"]

import { useStorage } from "@vueuse/core/index";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'KeywordPopover',
  props: ["descContent"],
  setup(__props) {

const props = __props;
const aiTheme = useStorage("ai-theme", "brown", localStorage);
const bofangIcon = ref("icon-bofang3");


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page-cover flex-row justify-center", _unref(aiTheme)])
  }, [
    (props.descContent)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("span", null, "关键词描述：", -1)),
          _createElementVNode("span", {
            innerHTML: props.descContent
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})